import { IApplicationState } from '../../types/redux';

export const selectUserGeoId = (state: IApplicationState): number => {
  return state.userGeo.userGeo;
};
